import FundingForm from './FundingForm'

export default FundingForm
